import classes from "../Table/Table.module.css";
import { Fragment, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import ActiveCurrenciesContext from "../../providers/CurrencyProvider";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Select from "react-select";
import axios from "axios";

export default function GlobalSettings() {
  const [newEntry, setNewEntry] = useState({
    selectedCost: { cost_id: null, cost_AccNum: "" },
    selectedSales: { sales_id: null, sales_AccNum: "" },
  });
  const initialState = [{ customer: [], vendor: [], settingsMatch: {} }];
  const [data, setData] = useState(initialState);
  const [profilesList, setProfilesList] = useState([]);
  const [toggledItems, setToggledItems] = useState({});
  const IASLiveMapper = "IAS Libra Live"; 

  const URL = "/api/global-settings";

  const getData = async () => {
    const response = await axios.get(URL);
    setData({
      customer: response.data.customer,
      vendor: response.data.vendor,
      settingsMatch: response.data.settingsMatch,
    });
    setProfilesList(response.data.invoicingProfiles);
  };

  const getDescription = (type, id) => {
    let record = type.find((x) => x.accountId == id);
    return record?.description ?? "N/A";
  };

  const handleSaveClick = async () => {
    if (
      newEntry.selectedCost.cost_id == null ||
      newEntry.selectedSales.sales_id == null
    ) {
      return;
    }
    let payload = {
      sales_Id: newEntry.selectedSales.sales_id,
      sales_AccNum: newEntry.selectedSales.sales_AccNum,
      cost_Id: newEntry.selectedCost.cost_id,
      cost_AccNum: newEntry.selectedCost.cost_AccNum,
    };
    const response = await axios.post(URL, payload);
    setNewEntry({
      selectedCost: { cost_id: null, cost_AccNum: "" },
      selectedSales: { sales_id: null, sales_AccNum: "" },
    });
  };

  const handleVendorSelectChange = (event) => {
    if (event) {
      newEntry.selectedCost.cost_id = event.accountId;
      newEntry.selectedCost.cost_AccNum = event.accNum;
    }
    setNewEntry({
      ...newEntry,
    });
  };
  const handleCustomerSelectChange = (event) => {
    if (event) {
      newEntry.selectedSales.sales_id = event.accountId;
      newEntry.selectedSales.sales_AccNum = event.accNum;
    }
    setNewEntry({
      ...newEntry,
    });
    console.log(newEntry);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: "500px !important",
      overflowY: "auto",
      zIndex: 9999,
      width: "100%",
    }),
    control: (provided) => ({
      ...provided,
      width: "100%",
    }),
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        getData();
      } catch (e) {
        console.error("Error fetching data: ", e);
      }
    };
    fetchData();
  }, []);

  const handleToggle = async (profile) => {
    let foundProfile = profilesList.find(
      (pro) => pro.profileId === profile.profileId
    );
    if (foundProfile) {
      foundProfile.status =
        foundProfile.status === "included" ? "excluded" : "included";
    }
    await axios.post(`${URL}/invoicing-profiles`, foundProfile);
    getData();
  };

  useEffect(() => {}, [data, newEntry]);

  return (
    <Fragment>
      {!IASLiveMapper && 
      <Table col-4 hover bordered="false" responsive order>
        
        <thead>
          <tr>
            <th>Free Line Cost</th>
            <th>Free Line Sales</th>
          </tr>
        </thead>
        <tbody>
          {data.settingsMatch && (
            <tr key={data.settingsMatch.cost_Id}>
              <td>
                {data.settingsMatch.cost_Id
                  ? getDescription(data.vendor, data.settingsMatch.cost_Id)
                  : "N/A"}
              </td>
              <td>
                {data.settingsMatch.sales_Id
                  ? getDescription(data.customer, data.settingsMatch.sales_Id)
                  : "N/A"}
              </td>
            </tr>
          )}
          <tr>
            <td>
              <div>
                <Select
                  className="select"
                  menuPlacement="top"
                  options={data.vendor}
                  onChange={handleVendorSelectChange}
                  getOptionLabel={(option) => option.description}
                  getOptionValue={(option) => option.accountId}
                  isClearable={true}
                  isSearchable={true}
                  placeholder="Select an option"
                  styles={customStyles}
                />
              </div>
            </td>
            <td>
              <div>
                <Select
                  menuPlacement="top"
                  options={data.customer}
                  getOptionLabel={(option) => option.description}
                  getOptionValue={(option) => option.accountId}
                  onChange={handleCustomerSelectChange}
                  isClearable={true}
                  isSearchable={true}
                  placeholder="Select an option"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </Table>
}
 {!IASLiveMapper && 
      <Table hover bordered="false" responsive order>
        <thead>
          <tr>
            <th>Invoicing Profile Name</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {profilesList && profilesList.length > 0 ? (
            profilesList.map((obj) => (
              <tr key={obj.profileId}>
                <td>{obj.name}</td>
                <td>
                  <Button
                    onClick={() => handleToggle(obj)}
                    variant={
                      obj.status == "excluded"
                        ? "outline-danger"
                        : "outline-success"
                    }
                  >
                    {obj.status}
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="2">No Currencies Data.</td>
            </tr>
          )}
        </tbody>
      </Table>}
      <Link to="/">
        <Button variant="outline-danger">Main Menu</Button>
      </Link>
      <Button
        variant="outline-primary"
        onClick={handleSaveClick}
        // disabled={disableSave}
      >
        Save
      </Button>
    </Fragment>
  );
}
